import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSortUp = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M2.48006 8.05994C2.36006 8.05994 2.24006 8.00994 2.14006 7.91994C1.95006 7.72994 1.95006 7.42994 2.14006 7.23994L6.19006 3.18994L10.2201 7.21994C10.4101 7.40994 10.4101 7.70994 10.2201 7.89994C10.0301 8.08994 9.73006 8.08994 9.54006 7.89994L6.68006 5.03994V20.1299C6.68006 20.4099 6.46006 20.6299 6.18006 20.6299C5.90006 20.6299 5.68006 20.4099 5.68006 20.1299V5.05994L2.82006 7.91994C2.73006 8.00994 2.60006 8.05994 2.48006 8.05994Z' />
    <path d='M22.0201 7.34994C22.0201 7.62994 21.8001 7.84994 21.5201 7.84994H14.1501C13.8701 7.84994 13.6501 7.62994 13.6501 7.34994C13.6501 7.06994 13.8701 6.84994 14.1501 6.84994H21.5201C21.8001 6.84994 22.0201 7.06994 22.0201 7.34994Z' />
    <path d='M20.1601 11.9999C20.1601 12.2799 19.9401 12.4999 19.6601 12.4999H14.1501C13.8701 12.4999 13.6501 12.2799 13.6501 11.9999C13.6501 11.7199 13.8701 11.4999 14.1501 11.4999H19.6601C19.9401 11.4999 20.1601 11.7199 20.1601 11.9999Z' />
    <path d='M13.6501 16.6499C13.6501 16.9299 13.8701 17.1499 14.1501 17.1499H17.8001C18.0801 17.1499 18.3001 16.9299 18.3001 16.6499C18.3001 16.3699 18.0801 16.1499 17.8001 16.1499H14.1501C13.8701 16.1499 13.6501 16.3699 13.6501 16.6499Z' />
  </svg>
);
export default SvgSortUp;
